import { UnsubscribeRequest } from '../model/snapshotData';

export const subscribeToChannel = (messageHandlers: any, unsubscribeHandlers?: any) => {
  return (key: string, callback: (data: any) => void, onUnsubscribe?: (data: any) => void) => {
    messageHandlers.current.set(key, callback);

    if (onUnsubscribe && unsubscribeHandlers) {
      unsubscribeHandlers?.current?.set(key, onUnsubscribe);
    }
  };
};

export const unsubscribeFromChannel = (
  sendMessage: any,
  activeChannelsRef: any,
  messageHandlers: any,
) => {
  return (subscriptionKey: string) => {
    if (!subscriptionKey) return;

    const channelToUnsubscribe = activeChannelsRef.current[subscriptionKey];
    if (channelToUnsubscribe) {
      reqUnsubscribeChannel(
        channelToUnsubscribe,
        activeChannelsRef.current,
        subscriptionKey,
        sendMessage,
        messageHandlers,
      );
    }
  };
};

const reqUnsubscribeChannel = (
  channel: number,
  activeChannel: any,
  subscriptionKey: string,
  sendMessage: any,
  messageHandlers: any,
) => {
  const req = new UnsubscribeRequest('unsubscribe_channel', channel);
  sendMessage(JSON.stringify(req));

  delete activeChannel[subscriptionKey];
  messageHandlers.current.delete(subscriptionKey);
};

export const unsubscribeAllChannelsInTabOverview = (
  sendMessage: any,
  activeChannelsRef: any,
  messageHandlers: any,
) => {
  return (token: string) => {
    const checkIfIsACustomWidget = (key: string) => {
      if (key.includes('-id-')) {
        const split = key.split('-id-');

        if (split.length > 1 && split[0] !== 'default') {
          return true;
        }
      }

      return false;
    };

    const channelsToUnsubscribe = Object.keys(activeChannelsRef.current).filter(
      (subscriptionKey) =>
        subscriptionKey.endsWith(`_${token}`) && !checkIfIsACustomWidget(subscriptionKey),
    );

    channelsToUnsubscribe.forEach((subscriptionKey) => {
      unsubscribeFromChannel(sendMessage, activeChannelsRef, messageHandlers)(subscriptionKey);
    });
  };
};

export const unsubscribeByWidget = (
  sendMessage: any,
  activeChannelsRef: any,
  messageHandlers: any,
) => {
  return (widget: string) => {
    const channelsToUnsubscribe = Object.keys(activeChannelsRef.current).filter((subscriptionKey) =>
      subscriptionKey.includes(`${widget}`),
    );

    channelsToUnsubscribe.forEach((subscriptionKey) => {
      unsubscribeFromChannel(sendMessage, activeChannelsRef, messageHandlers)(subscriptionKey);
    });
  };
};
